<template>
  <v-menu
    v-model="menuPicker"
    :close-on-content-click="false"
    :disabled="disabled"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :label="label"
        :placeholder="placeholder"
        v-bind="attrs"
        :disabled="disabled"
        readonly
        :value="selectedDate | date(false, true)"
        outlined
        dense
        :clearable="isClearable"
        v-on="on"
        @input="handleInput"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="selectedDate"
      :disabled="disabled"
      no-title
      :max="max"
      :min="min"
      @input="menuPicker = false"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
import {
  computed, ref, watch, onMounted,
} from '@vue/composition-api'
import moment from 'moment'

export default {
  props: {
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    max: { type: String, default: '9999-12-31', required: false },
    min: { type: String, default: '0001-01-01', required: false },
    default: { type: String, default: '', required: false },
    disabled: {
      type: Boolean,
      default() {
        return false
      },
    },
    clearable: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  setup(props, { emit }) {
    const selectedDate = ref('')
    const menuPicker = ref(false)

    const SetDate = value => {
      if (value) {
        selectedDate.value = value
      }
    }

    const Reset = () => {
      if (props.default !== '') {
        selectedDate.value = moment(props.default).toISOString(true)
      } else {
        selectedDate.value = ''
      }
    }

    // Se usa cuando se limpia a vacío TODO: Revisar bien
    const handleInput = value => {
      if (!value) {
        Reset()
      }
    }

    const isClearable = computed(() => props.clearable && props.default !== selectedDate.value)

    watch(selectedDate, () => {
      if (selectedDate.value !== '') {
        emit('selectedDate', moment(selectedDate.value).format('YYYY-MM-DD'))
      } else {
        emit('selectedDate', '')
      }
    })

    watch(() => props.min, newValue => {
      if (new Date(newValue) > new Date(selectedDate.value)) {
        selectedDate.value = newValue
      }
    })

    onMounted(() => {
      Reset()
    })

    return {
      selectedDate,
      menuPicker,
      isClearable,
      SetDate,
      Reset,
      handleInput,
    }
  },
}
</script>
